/*
 * -----------------------------------------------
 * SET FUNCTIONALITY POPUP GENERATION AND BINDINGS
 * -----------------------------------------------
 */

$(document).ready(function () {
  /*
   * --------
   * HELPERS
   * --------
   */

  const icon_arrow_bottom = `
      <svg class="icon icon-arrow-bottom" width="15px" height="8px" viewBox="0 0 15 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-266.000000, -1003.000000)" fill="#001D51" fill-rule="nonzero">
                <g transform="translate(266.000000, 1003.000000)">
                    <path d="M14.6808511,0.3 L14.6808511,0.3 C14.4680851,0.1 14.2553191,0 13.9361702,0 L13.9361702,0 C13.6170213,0 13.4042553,0.1 13.1914894,0.3 L7.55319149,5.7 L1.80851064,0.3 C1.38297872,-0.1 0.744680851,-0.1 0.319148936,0.3 C-0.106382979,0.7 -0.106382979,1.3 0.319148936,1.7 L6.70212766,7.8 C7.0212766,7.9 7.23404255,8 7.55319149,8 C7.87234043,8 8.08510638,7.9 8.29787234,7.7 L14.6808511,1.6 C14.893617,1.4 15,1.2 15,0.9 C15,0.7 14.893617,0.5 14.6808511,0.3 Z" id="Path"></path>
                </g>
            </g>
        </g>
      </svg>
    `;

  filesPath = "//cdn.shopify.com/s/files/1/0739/3825/files/";

  function lookupVariant(variants, option1, option2) {
    var result = $.grep(variants, function (v) {
      return v.option1 === option1 && v.option2 === option2;
    })[0];
    return result;
  }

  function generateSizeOptionsHTML(product, color) {
    var variantsOfColor = $.grep(product.variants, function (v) {
      return v.option1 === color;
    });

    var sizes = $.map(variantsOfColor, function (v, idx) {
      return v.option2;
    });

    var sizeOptions = $.map(sizes, function (size, idx) {
      var soldOut =
        lookupVariant(variantsOfColor, color, size).inventory_quantity == 0;
      if (soldOut) {
        return `<option disabled="disabled" value="${size}">${size} – SOLD OUT</option>`;
      } else {
        return `<option value="${size}">${size}</option>`;
      }
    }).join("");

    return sizeOptions;
  }

  function refreshSizeOptions(dropdown, product, color) {
    var variantsOfColor = $.grep(product.variants, function (v) {
      return v.option1 === color;
    });

    dropdown.find("option").each(function () {
      var size = $(this).attr("value");
      var soldOut =
        lookupVariant(variantsOfColor, color, size).inventory_quantity == 0;
      if (soldOut) {
        $(this).attr("disabled", "disabled").text(`${size} – SOLD OUT`);
      } else {
        $(this).removeAttr("disabled").text(`${size}`);
      }
    });
  }

  function recalculateSubtotal() {
    var subtotal = 0;
    $(".set-popup__product").each(function () {
      subtotal += parseInt($(this).attr("data-variant-price"));
    });
    $(".set-popup__subtotal").text(
      Shopify.formatMoney(subtotal, window.shop["moneyFormat"])
    );
  }

  function guessSetName() {
    /* This is really, REALLY quick and dirty, but time's a pressing.
     * I hope, we can get an approval on a tag-based set name system.
     */
    var titles = $.unique(
      $(".product__title")
        .map(function () {
          return $(this).text();
        })
        .get()
    );
    var maxCommonIdx = -1;
    for (let i = 0; i < titles[0].length; i++) {
      if (titles[0][i] === titles[1][i]) {
        maxCommonIdx = i;
      } else {
        break;
      }
    }
    return maxCommonIdx >= 0 ? titles[0].substr(0, maxCommonIdx) : "";
  }

  function uniqueStrings(array) {
    return $.grep(array, function (el, index) {
      return index === $.inArray(el, array);
    });
  }

  function getAvailableImage(product, variant) {
    var_featured = $(variant.featured_image);
    if (var_featured.length !== 0) {
      return var_featured[0].src;
    } else {
      return product.featured_image;
    }
  }

  function finalizePopup(popup) {
    /* Close bPopup, restore text, open side cart. */
    reloadCart();
    popup.close();

    /* Switch button to text */
    $(".set-popup__add-to-cart--button_spinner").css("display", "none");
    $(".set-popup__add-to-cart--button_text").css("display", "inline");

    $(".product_cart-custom").addClass("product_cart-custom--open");
    $(".product_cart-custom_overlay").addClass("product_cart-custom_overlay--open");
  }

  function callback_scrollToTopOf(jqCanvas, jqElement) {
    return function () {
      jqCanvas.animate(
        {
          scrollTop: jqElement.offset().top - jqCanvas.offset().top,
        },
        1000
      );
    };
  }

  /* END HELPERS */

  /*
   * -------------------------
   * PAGE-LEVEL INITIALIZATION
   * -------------------------
   */

  /* Destroy set buttons if...  */
  if (
    /* ...there is only one product form on the page... */
    $(".product__form").length === 1 ||
    /* ...or there is no popup... */
    $(".set-popup-canvas").length === 0
  ) {
    $(".product__scroll-to-set, .product__add-full-set").remove();
  }

  /* END PAGE-LEVEL INITIALIZATION */

  /*
   * ---------------------------
   * PAGE-LEVEL BEHAVIOR BINDING
   * ---------------------------
   */

  /* Browse Set button ( Scrolling to other set items ) */
  $(".product__scroll-to-set").click(
    callback_scrollToTopOf(
      $([document.documentElement, document.body]),
      $(".related-products__title")
    )
  );

  /* Add Set to cart button ( Open popup and render the products inside ) */
  $(".product__add-full-set").click(function () {
    /* Open popup */
    var gSetPopup = $(".set-popup-canvas").bPopup({
      position: ["auto", 10],
      positionStyle: "fixed",
      closeClass: "set-popup__close",
      onOpen: function () {
        var setPopup = $(".set-popup");
        var isInitialized = setPopup.attr("data-initialized");

        /* Clear data from previous instances */
        $(".set-popup__products").empty();

        /* Construct product block from each product form */
        $(".product__form").each(function () {
          /* Fetch product JSON and active variant options */
          var form = $(this);
          var handle = form
            .find(".product__variants")
            .attr("data-product-handle");
          var active_size =
            form.find('.single-option-selector[data-option="option2"]').val() ||
            form.find('.single-option-selector[data-option="option2"]')[0]
              .value;
          var active_color = form
            .find(".swatch__item--active")
            .attr("data-value");

          /* Quick fix for 'Pairs-With' blocks that have no-active-swatches */
          /* Ideally, this should be fixed in the Pairs code */
          if (!active_color) {
            active_color = form
              .find(".targetProduct")
              .addClass("swatch__item")
              .first()
              .addClass(".swatch__item--active")
              .attr("data-value");
          }

          /* If product blocks are present, insert internal separator */

          if ($(".set-popup__product").length > 0) {
            $(".set-popup__products").append(
              `<hr class="set-popup__hr set-popup__hr--internal">`
            );
          }

          /* Add product block holder */
          $(".set-popup__products").append(`
            <div class="set-popup__product" data-handle="${handle}"</div>`);

          /* Fetching is async, meaning that products could added to the popup in random order! */
          /* This is why a holder is provided synchronously before fetching */
          fetch("/products/" + handle + ".js")
            .then(function (response) {
              return response.json();
            })
            .then(function (product) {
              /* Gather variables for initializing block */
              
              var active_variant = lookupVariant(
                product.variants,
                active_color,
                active_size
              );

              /* -- Generate colors -- */

              var colors = uniqueStrings(
                $.map(product.variants, function (v, idx) {
                  return v.option1;
                })
              );

              var colorOptions = $.map(colors, function (color, idx) {
                /* Can't use liquid img tags for generic filenames.
                   Hardcoding path to Files as a workaround. This throws 404's, tho */
                swatchHandle = color.toLowerCase().replace(/\s/g, "-");
                swatchURL = `${filesPath}${swatchHandle}_small.png`;
                return `
                  <div title="${color}"
                       class="set-popup__product-swatch"
                       data-color="${color}" 
                       data-image-src="${swatchURL}">
                    <label class="swatch__label form__label"
                            style="background-color: ${swatchHandle};
                                   background-image: url(${swatchURL})" id="swatch__label-lb"> 
                  </div>
                `;
              }).join("");

              var colorSelector = `
              <span class="form__label set-popup__label" >Color: </span>
              <span class="set-popup__color-label"></span>
              <div class="form__control  swatch set-popup__option-control set-popup__swatches">
                ${colorOptions}
              </div>
              `;

              /* -- Generate sizes -- */

              var sizeOptions = generateSizeOptionsHTML(product, active_color);
              var sizeSelector = `
                <span class="form__label set-popup__label" >Size:</span>
                <span class="set-popup__label-warning">Please select an available variant</span>
                <div class="form__select set-popup__option-control set-popup__size-dropdown-wrapper">
                  ${icon_arrow_bottom}
                  <select class="single-option-selector set-popup__size-dropdown" data-option="option2">
                    ${sizeOptions}
                  </select>
                </div>
              `;

              /* Add product block with initial values */
              $(`.set-popup__product[data-handle="${handle}"]`)
                .attr("data-variant-id", active_variant.id)
                .attr(
                  "data-variant-price",
                  active_variant.price
                ).append(`                
                  <div class="set-popup__product-image">
                    <img src="${getAvailableImage(product, active_variant)}">
                  </div>
                  <div class="set-popup__product-description">
                    <h2 class="set-popup__product-title">${product.title}</h2>
                    <div class="set-popup__product-options">
                      <div class="set-popup__product-option">
                        ${sizeSelector}
                      </div>
                      <div class="set-popup__product-option">
                        ${colorSelector}
                      </div>
                    </div>
                  </div>            
                  `);

              /* -- Make initial selections -- */
              var thisProductDiv = $(
                `.set-popup__product[data-handle="${handle}"]`
              );
              var sizeSelectorObj = thisProductDiv.find(
                `select[data-option="option2"]`
              );

              /* Color */
              thisProductDiv
                .find(
                  `.set-popup__product-swatch[data-color="${active_color}"]`
                )
                .addClass("set-popup__product-swatch--active");
              thisProductDiv.find(`.set-popup__color-label`).text(active_color);

              /* Size */
              sizeSelectorObj.find("option").each(function (e) {
                if ($(this).val() === active_size) {
                  sizeSelectorObj[0].selectedIndex = e;
                }
              });
              thisProductDiv.attr("data-variant-price", active_variant.price);
              recalculateSubtotal();

              /* -- Bind selectors -- */

              /* Bind size selector */
              sizeSelectorObj.change(function () {
                active_color = thisProductDiv
                  .find(`.set-popup__product-swatch--active`)
                  .attr("data-color");
                active_size = sizeSelectorObj.val() || sizeSelectorObj[0].value;
                active_variant = lookupVariant(
                  product.variants,
                  active_color,
                  active_size
                );

                thisProductDiv.attr("data-variant-id", active_variant.id);
                thisProductDiv
                  .find(".set-popup__product-image")
                  .attr("src", `${getAvailableImage(product, active_variant)}`);
                thisProductDiv.attr("data-variant-price", active_variant.price);

                recalculateSubtotal();
              });

              /* Bind color swatches */
              thisProductDiv
                .find(`.set-popup__product-swatch`)
                .click(function () {
                  if (!$(this).hasClass(`.set-popup__product-swatch--active`)) {
                    $(this)
                      .siblings()
                      .removeClass("set-popup__product-swatch--active")
                      .end()
                      .addClass("set-popup__product-swatch--active");

                    active_color = $(this).attr("data-color");
                    
                    active_size =
                      sizeSelectorObj.val() || sizeSelectorObj[0].value;
                    active_variant = lookupVariant(
                      product.variants,
                      active_color,
                      active_size
                    );

                    thisProductDiv
                      .find(`.set-popup__color-label`)
                      .text(active_color);
                    thisProductDiv.attr("data-variant-id", active_variant.id);
                    thisProductDiv
                      .find(".set-popup__product-image img")
                      .attr(
                        "src",
                        `${getAvailableImage(product, active_variant)}`
                      );
                    thisProductDiv.attr(
                      "data-variant-price",
                      active_variant.price
                    );
                    refreshSizeOptions(sizeSelectorObj, product, active_color);
                  }
                });
            })
            .catch(console.log);
        });

        /* -- Popup-level Initialization -- */

        if (isInitialized === "false") {
          /* Inject set name into popup */
          /* If the set tag contains a name, use it. If not, use a guess */
          dataSetName = $(".set-popup").data("set-name");
          var setName = dataSetName === "set" ? guessSetName() : dataSetName;
          // var setName = guessSetName(); /* Guess-only */

          $(".set-popup__popup-title").text(`Buy ${setName} Set`);
          $(".set-popup__set-title").text(`${setName} Set`);

          /* Bind Add Set to Cart button (popup-level -- add to cart via CartJS) */
          $(".set-popup__add-to-cart").click(function () {
            /* Add all variants to cart.
             * CartJS helps with queueing API calls and prompting callbacks.
             * Cart is reloaded on last callback. */

            /* If some variants are unavailable, highlight them and return. */
            unavailable_variants_found = false;
            $(".set-popup__size-dropdown").each(function (idx) {
              if (!$(this).val()) {
                callback_scrollToTopOf(
                  $(".set-popup-canvas"),
                  $(this).closest(".set-popup__product")
                )();
                $(this)
                  .closest(".set-popup__product-option")
                  .find(".set-popup__label")
                  .next(".set-popup__label-warning")
                  .fadeIn(300)
                  .delay(2000)
                  .fadeOut(400);
                unavailable_variants_found = true;
                return false; /* Stop iterations */
              }
            });

            if (unavailable_variants_found) {
              return false;
            } /* Do not add anything to cart */

            /* Switch button to spinner */
            $(".set-popup__add-to-cart--button_text").css("display", "none");
            $(".set-popup__add-to-cart--button_spinner")
              .css("display", "inline");

            var products_last_index = $(".set-popup__product").length - 1;
            $(".set-popup__product").each(function (e) {
              CartJS.addItem(
                $(this).attr("data-variant-id"),
                1,
                {},
                {
                  /* Success callback. */
                  success: function (data, textStatus, jqXHR) {
                    if (e === products_last_index) {
                      finalizePopup(gSetPopup);
                    }
                  },
                  /* Error callback. */
                  error: function (jqXHR, textStatus, errorThrown) {
                    console.log(
                      `Error in CartJS.addItem(...): ${textStatus} / ${errorThrown}`
                    );
                    if (e === products_last_index) {
                      finalizePopup(gSetPopup);
                    }
                  },
                }
              );
            });
          }); /* END Bind Add Set to Cart button */

          /* Switch init status */
          setPopup.attr("data-initialized", "true");
        }

        /* END Popup-level Initialization */
      } /* END bPopup's onOpen */,
    }); /* END bPopup open call */
  }); /* END external Add Set to cart button binding */

  /* END PAGE-LEVEL BEHAVIOR BINDING */
}); /* END document-ready */
